import request from '../../axios';

export const getSubBrandOwner = async (brandId: number) => {
  const {data}: {data: ISubBrand[]} = await request.get(
    `/api/v2/store/list/sub-brand/brand/${brandId}`,
  );

  return data;
};
